import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-tertiary)";

function IconGridGap({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#hya0qqi9xa)">
                <path d="M4 5.5h4V4h1v4H8V6.5H4V8H3V4h1v1.5z" fill="#3F3F46"/>
                <path d="M.5 0a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 .5 0zM11.5 0a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0V.5a.5.5 0 0 1 .5-.5z" fill={fill}/>
            </g>
            <defs>
                <clipPath id="hya0qqi9xa">
                    <path fill="#fff" d="M0 0h12v12H0z"/>
                </clipPath>
            </defs>
        </svg>

    );
}

export default IconGridGap;

